module.exports = __webpack_public_path__ + "static/media/Oak+Fort-logo-thin-white.7d3abfcd.svg";